/**
 * retorna la fecha actual en formato MM/DD/YYYY
 */
export const getFechaFormato1 = (): string => {
  const today = new Date().toLocaleDateString('en-CA')
  const array = today.split('-')
  if (array.length > 2) return `${array[1]}/${array[2]}/${array[0]}`
  return ''
}

export const getHoraNow = (): string => {
  let time = new Date()
  return (
    ('0' + time.getHours()).slice(-2) +
    ':' +
    ('0' + time.getMinutes()).slice(-2) +
    ':' +
    ('0' + time.getSeconds()).slice(-2)
  )
}

export const getFechaCA = (fecha: string): string => {
  if (!fecha) return ''
  const array = fecha.split('-')
  if (array.length > 2) return `${array[2]}/${array[1]}/${array[0]}`
  return fecha
}

export const fechaMayorActual = (fechaExpiracion: string): boolean => {
  const expiracion = new Date(fechaExpiracion)
  const now = new Date()
  return now > expiracion
}

export function convertDateFormatAnular(inputDate: string) {
  const [day, month, year] = inputDate.split('/')
  return `${year}-${month}-${day}`
}

export const getDateOperacion = (numero: number) => {
  let date = new Date(`${new Date().toLocaleDateString('en-CA')}T00:00:00`)
  date.setFullYear(date.getFullYear() + numero)
  return date.toLocaleDateString('en-CA')
}

export const validarFechaEntreMeses = (mes: number, fecha: any):boolean => {
  const partes = `${fecha ?? ''}`.split('-').map(Number);

  if (partes.length !== 3 || partes.some(isNaN)) return false;

  const fechaActual = new Date();
  let fechaConvertida = new Date(partes[0], partes[1] - 1, partes[2]);
 
  // Agrega 3 meses a la fecha dada
  fechaConvertida.setMonth(fechaConvertida.getMonth() + mes);

  // Retorna true si no han pasado mas de 3 meses
  return fechaActual <= fechaConvertida;
}

export const getDateOperacionMes = (numero: number) => {
  let date = new Date(`${new Date().toLocaleDateString('en-CA')}T00:00:00`)
  date.setMonth(date.getMonth() + numero)
  return date.toLocaleDateString('en-CA')
}

export const getMinDateRetroactiva = (diasRetroactivos: number, todayISO: string): string => {
  const date = new Date(`${todayISO}T00:00:00`)
  date.setDate(date.getDate() - diasRetroactivos)
  return date.toLocaleDateString('en-CA')
}

export const convertirFechaParaFechaDoc = (fechaISO: string): string => {
  const [y, m, d] = fechaISO.split('-')
  return `${m}/${d}/${y}`
}

export const validacionFechaMenorIgual = (
  fecha: string,
  name: string,
  cantidad: number
): string => {
  let fecha_nacimiento = new Date(fecha)
  let fecha_Actual = new Date()
  let edad = (fecha_Actual.getTime() - fecha_nacimiento.getTime()) / (1000 * 60 * 60 * 24 * 365.25)
  if (edad > cantidad) return `${name} incorrecta`
  return ''
}